module.exports = __webpack_public_path__ + "img/convorating.d3643961.svg";